module.exports = __webpack_public_path__ + "ye.svg?58d8d56309a5718c3a4f31be6cdf223e";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/ye.svg
// module id = 1699
// module chunks = 0